export const useScrollSpy = () => {
  const onNavigate = (sectionName: string) => {
    const el = document.querySelector(`[data-scrollname=${sectionName}]`)
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }

  return {
    onNavigate
  }
}
